import React from "react";
import AppHeader from "Layout/AppHeader";

// Components
import Default from "./Default";
import PageHeading from "Layout/AppMain/PageHeading";

const Export = () => {
    return (
        <>
           <PageHeading />
        <Default />
        </>
    )
};

export default Export;